import { toast } from 'react-toastify';

// Function to handle report submission for a general report
export const handleReportSubmit = async (userId, formData, liveCsrfToken,screenshot, t) => {
    try {
        console.log('Submitting general report:', formData);

        const response = await submitReport(userId, formData, liveCsrfToken);

        // Show success toast on successful submission
        toast.success(t("Report Issue Submitted Successfully"));

        return response;
    } catch (error) {
        console.error('Error submitting report:', error);

        // Show error toast on submission failure
        toast.error(t("Failed to Submit Report"));
        throw new Error(error.message);
    }
};

// Function to submit a general report
export const submitReport = async (userId, formData, liveCsrfToken) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/issue-reports/${userId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-csrf-token': liveCsrfToken, // Send the CSRF token in the headers
            },
            credentials: 'include', // Ensure cookies (for the session) are sent
            body: JSON.stringify(formData),
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Failed to submit report.');

        return data;
    } catch (error) {
        throw new Error(error.message);
    }
};

// Function to handle report submission for a card-related issue
export const handleReportSubmitCard = async (userId, formData, liveCsrfToken,t) => {
 
    try {
        console.log('Submitting card issue report:', formData);

        const response = await submitReportCard(userId, formData, liveCsrfToken);

        // Show success toast on successful submission
        toast.success(t('Card Issue Submitted Successfully'));

        return response;
    } catch (error) {
        console.error('Error submitting card issue report:', error);

        // Show error toast on submission failure
        toast.error(t('Failed to Submit Card Issue Report'));
        throw new Error(error.message);
    }
};


// Function to submit a card-related issue report
export const submitReportCard = async (userId, formData, liveCsrfToken) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/issue-reports-card/${userId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-csrf-token': liveCsrfToken, // Send the CSRF token in the headers
            },
            credentials: 'include', // Ensure cookies (for the session) are sent
            body: JSON.stringify(formData),
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Failed to submit card issue report.');

        return data;
    } catch (error) {
        throw new Error(error.message);
    }
};
